import React from 'react';
import qs from 'qs';
import { RESET_PASSWORD_URL } from '../../constants/apiUrls/apiUrls';
import callApi from '../../utils/callApi';
import Alert from '../../components/generalComponents/Alert';

const content1 = 'You must enter a username or email address';
class ResetPasswordPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            email: '',
            isAlertVisible: false,
            content: ''
        };
    }
    showAlert = content => {
        this.setState({
            isAlertVisible: true,
            content
        });
    };
    hideAlert = () => {
        this.setState({
            isAlertVisible: false,
            content: ''
        });
    };
    handleChange = name => e => {
        this.setState({
            [name]: e.target.value
        });
    };
    handleSubmit = e => {
        const { username, email } = this.state;
        let data = {};
        e.preventDefault();
        if (!(username || email)) {
            // show alert
            return this.showAlert(content1);
        } else if (username) {
            data = { username: username.trim() };
        } else if (email) {
            data = { email: email.trim() };
        }
        callApi(RESET_PASSWORD_URL, 'POST', false, qs.stringify(data), {
            'content-type': 'application/x-www-form-urlencoded'
        })
            .then(res => {
                if (res.status === 200) {
                    localStorage.setItem('resetLinkSent', true);
                    this.props.history.push('/account/login');
                }
            })
            .catch(err => console.log(err));
    };
    render() {
        const { username, email, isAlertVisible, content } = this.state;
        return (
            <div className="content">
                {isAlertVisible && (
                    <Alert onClose={this.hideAlert}>{content}</Alert>
                )}
                <div className="container">
                    <div className="row-r">
                        <div className="col-xs-12 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4">
                            <div className="nakednews-form-container new-password-form">
                                <div className="nakednews-form-title">
                                    Recover your account
                                </div>
                                <div className="nakednews-form">
                                    <div className="nakednews-form-error" />
                                    <div className="nakednews-form-text">
                                        Please enter one of the fields
                                    </div>
                                    <form
                                        noValidate="novalidate"
                                        className="formtastic form-horizontal password"
                                        acceptCharset="UTF-8"
                                        onSubmit={this.handleSubmit}
                                    >
                                        <input
                                            name="utf8"
                                            type="hidden"
                                            defaultValue="✓"
                                        />
                                        <input
                                            type="hidden"
                                            name="authenticity_token"
                                            defaultValue="NLcovCIOePYeX3ap6LUfHA/omeBlvqXuFxspVhEz9Fk0aW40ZS/mBzZkPHyXyPIpjA14NZekqSgjJ6NjhKSnmA=="
                                        />
                                        <div
                                            className="string input required stringish form-group"
                                            id="password_username_input"
                                        >
                                            <div className="col-lg-9">
                                                <input
                                                    className="form-input username"
                                                    placeholder="Username"
                                                    id="password_username"
                                                    name="username"
                                                    type="text"
                                                    value={username}
                                                    onChange={this.handleChange(
                                                        'username'
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="new-password-form-separator">
                                            or
                                        </div>
                                        <div
                                            className="email input required stringish form-group"
                                            id="password_email_input"
                                        >
                                            <div className="col-lg-9">
                                                <input
                                                    className="form-input email"
                                                    placeholder="Email address"
                                                    id="password_email"
                                                    name="email"
                                                    type="email"
                                                    value={email}
                                                    onChange={this.handleChange(
                                                        'email'
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="col-lg-offset-3 col-lg-9">
                                                <button
                                                    name="button"
                                                    type="submit"
                                                    className="btn btn-black action-button"
                                                    id="password_submit_action"
                                                >
                                                    Reset password
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <a
                                    className="nakednews-form-link"
                                    href="/account/login"
                                >
                                    &lt;&lt; Back to login
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ResetPasswordPage;
